// extracted by mini-css-extract-plugin
module.exports = {"holder":"VideoBlockStyles_holder__HcAS2","imgclass":"VideoBlockStyles_imgclass__jKiKf","copy":"VideoBlockStyles_copy__ORu4C"};